<template>
    <main>
        <!-- 顶部选择 出游类型 模块 -->
        <section class="tagSelected" v-if="category && category.length">
            <figure class="tagsWrap">
                <figcaption class="tagsItem" v-for="(item, index) in category" :key="index">{{ item.title }}</figcaption>
            </figure>
        </section>

        <!-- 热门推荐产品模块 -->
        <section class="hotProduct" v-if="hot_spus && hot_spus.length">
            <h2>热门推荐</h2>
            <ul class="hotProductWrap">
                <li class="hotProductItem" v-for="(item, index) in hot_spus" :key="index">
                    <div class="hotImgWrap"><img :src="item.cover_url" :alt="item.name" @error="loadImgError(item, index)">
                    </div>
                    <div class="productDesc">
                        <span>{{ item.name }}</span>
                        <p>￥ {{ item.starting_price }}</p>
                    </div>
                </li>
            </ul>
        </section>

    </main>
</template>

<script>
import $Travel from '@api/travel';
export default {
    components: {},
    data() {
        return {
            category: [], //旅游分类
            hot_spus: [], //热门产品
            optimum_spus: [] //优选产品
        }
    },
    computed: {

    },
    async created() {

        this.getHomeInfo();

    },
    methods: {
        // 获取首页基础信息
        async getHomeInfo() {
            let _this = this;
            await $Travel.getHomePageInfo().then((res) => {
                const {
                    category,
                    hot_spus,
                    optimum_spus
                } = res.data;
                _this.category = category || [];
                _this.hot_spus = hot_spus || [];
                _this.optimum_spus = optimum_spus || [];
            })
        },

        // 加载图片异常时
        loadImgError(item, index) {
            let _this = this;
            const { cover_url } = item;
            setTimeout(() => {
                _this.hot_spus[index]['cover_url'] = '';
                let getTimestamp = new Date().getTime();
                _this.hot_spus[index]['cover_url'] = cover_url + "?timestamp=" + getTimestamp
            }, 1500);


        }

    }
}
</script>

<style scoped src="./index.css"></style>
